import React, { useEffect, useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import socketService from '../../services/socket';
import './PracticeMatching.scss';

export const PracticeMatching = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(state => state.auth?.user || JSON.parse(localStorage.getItem('user') || '{}'));
  
  const [onlineCount, setOnlineCount] = useState(1);
  const [targetLanguage, setTargetLanguage] = useState('English');
  
  // Simulated language mapping
  const languageMap = {
    '1': 'English', '2': 'Spanish', '3': 'French', '4': 'German', '5': 'Chinese'
  };

  useEffect(() => {
    const stateLangId = location.state?.languageId;
    if (stateLangId && languageMap[stateLangId]) {
      setTargetLanguage(languageMap[stateLangId]);
    }

    const socket = socketService.getSocket();
    if (socket) {
      socket.on('onlineCount', (count) => {
        setOnlineCount(count);
      });

      socket.on('partnerFound', (data) => {
        // Proceed to a real call UI when partner found
        console.log('Partner found!', data);
        alert(`Found ${data.count} potential partners online! Waiting for them to accept.`);
      });

      socket.on('newPracticeRequest', (data) => {
        // Handle incoming request
        console.log('New request', data);
      });

      socket.on('matchConfirmed', (data) => {
        // Navigate to the video/audio call room
        console.log('Match confirmed', data);
        alert(`Match Confirmed with ${data.partner?.full_name}`);
      });
      
      socket.on('searchCancelled', () => {
        navigate('/practice');
      });
    }

    return () => {
      if (socket) {
        socket.off('onlineCount');
        socket.off('partnerFound');
        socket.off('newPracticeRequest');
        socket.off('matchConfirmed');
        socket.off('searchCancelled');
      }
    };
  }, [navigate, location.state]);

  const handleCancel = () => {
    const socket = socketService.getSocket();
    if (socket && user?._id) {
      socket.emit('cancelSearch', user._id);
    } else {
      navigate('/practice');
    }
  };

  return (
    <div className="practice-matching bg-white min-vh-100 d-flex flex-column align-items-center justify-content-center py-5">
      <Container className="d-flex flex-column align-items-center text-center">
        
        {/* Search Icon Animation */}
        <div className="pm-search-icon mb-4">
          <i className="bi bi-search text-primary" style={{ fontSize: '4rem' }}></i>
          <div className="pm-dots">
            <span className="dot text-primary">•</span>
            <span className="dot text-warning">•</span>
            <span className="dot text-primary">•</span>
          </div>
        </div>

        <h3 className="fw-bold mb-2">Finding your practice partner...</h3>
        <p className="text-muted fs-5 mb-5">
          We're looking for someone online<br/>
          who wants to practice <span className="text-primary fw-semibold">{targetLanguage}</span>
        </p>

        {/* Pulsing Avatar Group */}
        <div className="pm-pulsing-avatars mb-5 position-relative">
          <div className="pm-pulse-ring"></div>
          <div className="pm-avatars bg-white shadow-sm rounded-circle d-flex align-items-center justify-content-center gap-2 p-4 position-relative z-1" style={{ width: '160px', height: '160px' }}>
            <div className="position-relative">
              <i className="bi bi-person-fill text-primary" style={{ fontSize: '3rem' }}></i>
              <div className="position-absolute" style={{ top: '-15px', right: '-15px' }}>
                <div className="bg-primary text-white rounded-pill px-2 py-1 shadow-sm" style={{ fontSize: '0.6rem' }}>
                  <i className="bi bi-three-dots"></i>
                </div>
              </div>
            </div>
            <i className="bi bi-person-fill text-warning" style={{ fontSize: '3rem' }}></i>
          </div>
        </div>

        {/* Online Stats */}
        <div className="d-flex align-items-center gap-2 text-dark fw-semibold mb-2">
          <span className="bg-success rounded-circle" style={{ width: '8px', height: '8px' }}></span>
          People online now: <span className="text-primary">{onlineCount}</span>
        </div>
        <p className="text-muted small mb-4">This usually takes less than 29 seconds.</p>

        {/* Tip Banner */}
        <div className="bg-light text-muted p-3 px-4 rounded-3 d-flex align-items-center gap-3 mb-4" style={{ maxWidth: '400px' }}>
          <i className="bi bi-lightbulb text-primary fs-5"></i>
          <span className="small">Tip: Keep your app open and we'll notify you as soon as a match is found.</span>
        </div>

        <Button variant="link" className="text-danger text-decoration-none fw-semibold" onClick={handleCancel}>
          Cancel Search
        </Button>

      </Container>
    </div>
  );
};
